import { Field, NumericInput, TextOutput } from '../../../../../Core';
import { ListFieldSection } from '../../../../../Layout';
import { IWorksheetComponent } from '../../../../Core/types';
import { withInjectedProps } from '../../../../../Core/InjectedPropsContext';

let LoadIncrementDetailsSectionBase: React.FC<IWorksheetComponent> = () => {
  return (
    <ListFieldSection>
      <Field input={<NumericInput />} name="DesiredPressure" />
      <Field input={<TextOutput />} name="DesiredLoad" />
      <Field input={<TextOutput />} name="DesiredLoadInDivisions" />
      <Field input={<NumericInput />} name="IncrementLoadInDivisions" />
      <Field input={<TextOutput />} name="IncrementLoad" />
      <Field input={<TextOutput />} name="IncrementPressure" />
    </ListFieldSection>
  );
};

const LoadIncrementDetailsSection = withInjectedProps(LoadIncrementDetailsSectionBase);
export { LoadIncrementDetailsSection };
export default LoadIncrementDetailsSection;
